import { useEffect, useState } from 'react';
import { Alert, Button, Modal } from '../../ui';
import PanPicker, { panErrorMessages } from '../pages/sub-merchants/PanPicker';

export default function AssignPansModal({ isOpen, subMerchant, onClose, onSubmit }) {
  const [pans, setPans] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPans([]);
    setError('');
  }, [isOpen]);

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      await onSubmit(pans);
      onClose();
    } catch (err) {
      const panMessages = panErrorMessages(err.response?.data?.errors);
      setError(
        panMessages.length > 0
          ? panMessages.join(' ')
          : err.response?.data?.message || 'Something went wrong. Please try again.'
      );
    }
    setLoading(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={subMerchant ? `Assign PANs to ${subMerchant.name}` : 'Assign PANs'}
      size="lg"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button loading={loading} disabled={pans.length === 0} onClick={handleSubmit}>
            Assign PANs
          </Button>
        </>
      }
    >
      {error && (
        <Alert variant="danger" className="mb-4" onDismiss={() => setError('')}>
          {error}
        </Alert>
      )}
      <PanPicker subMerchantId={subMerchant?.id} selected={pans} onChange={setPans} />
    </Modal>
  );
}
